import { useEffect, useState } from "react";

const StrapiHealthCheck = ({ children }) => {
  const [strapiUp, setStrapiUp] = useState(true);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const checkStrapi = async () => {
      const urls = [
        `${process.env.REACT_APP_STRAPI_URL}/api/users/me`,
        "http://localhost:1337/api/users/me"
      ].filter(Boolean);

      for (const url of urls) {
        try {
          const response = await fetch(url);
          // Consider 200 or 401 as valid responses
          if (response.status === 200 || response.status === 401) {
            setStrapiUp(true);
            setChecked(true);
            return;
          }
        } catch {
          // try next URL
        }
      }

      setStrapiUp(false);
      setChecked(true);
    };

    checkStrapi();
  }, []);

  if (!checked) return null;

  if (!strapiUp) {
    return (
      <section>
        <div className="d-flex flex-column container min-vh-100">
          <div className="row align-items-center justify-content-center justify-content-lg-between my-auto">
            <div className="col-md-10 order-lg-1 text-center text-lg-start">
              <h1 className="mb-1 text-black" style={{ fontWeight: "bold" }}>
                Maintenance in progress
              </h1>
              <p className="display-5 text-black" style={{ lineHeight: "100%" }}>
                I'm performing maintenance or the backend is currently unavailable.
                <br />
                Please check back shortly.
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return children;
};

export default StrapiHealthCheck;
